import { Mail, Phone } from "lucide-react";
import { QUOTE_EMAIL, COMPANY_PHONE } from "../lib/constants";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="min-h-[70vh] bg-[#031a20] py-24">
      <div className="max-w-5xl mx-auto px-6 sm:px-8">
        <div className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-4">
          <span className="gold-rule" />Vegye fel velünk a kapcsolatot
        </div>
        <h1 className="font-serif text-5xl text-white mb-12">Beszéljünk a projektjéről.</h1>
        <div className="grid md:grid-cols-2 gap-8">
          {[
            { id: "email", i: Mail,  t: "E-mail",   d: QUOTE_EMAIL },
            { id: "phone", i: Phone, t: "Telefon", d: COMPANY_PHONE },
          ].map(({ id, i: Icon, t, d }) => (
            <div key={id} className="bg-[#04222a] border border-white/10 p-8">
              <Icon className="w-7 h-7 text-[#d4af37] mb-4" strokeWidth={1.5} />
              <div className="font-serif text-xl text-white">{t}</div>
              <div className="text-sm text-white/70 mt-2">{d}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
